

export interface User {
  id: string;
  fullName: string;
  email: string;
  referralCode: string;
  role: 'USER' | 'ADMIN' | 'SUPER_ADMIN';
  status: 'ACTIVE' | 'SUSPENDED';
  createdAt: string;
  avatarInitials: string;
}

export interface WalletData {
  availableBalance: number;
  totalDeposited: number;
  totalWithdrawn: number;
  totalEarnings: number;
  totalCommissions: number;
  accumulatedEarnings: number;
  todayEarnings: number;
}

export interface NodeData {
  status: 'ACTIVE' | 'INACTIVE' | 'EXPIRED';
  todayEarnings: number;
  totalEarnings: number;
  efficiency: number;
  multiplier: number;
  cycle: string | null;
  activationDate: string | null;
  expirationDate: string | null;
}

export interface Transaction {
  id: string;
  type: 'DEPOSIT' | 'WITHDRAWAL' | 'COMMISSION' | 'EARNINGS' | 'BONUS' | 'ENERGY';
  amount: number;
  currency: string;
  network: string | null;
  status: 'PENDING' | 'CONFIRMED' | 'COMPLETED' | 'REJECTED';
  txid: string | null;
  walletAddress: string | null;
  date: string;
  time: string;
  notes: string | null;
  userId: string;
}

export interface ReferralData {
  code: string;
  level1Count: number;
  level2Count: number;
  level3Count: number;
  level1Commission: number;
  level2Commission: number;
  level3Commission: number;
  totalCommission: number;
  availableCommission: number;
}

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'SUCCESS' | 'WARNING' | 'INFO' | 'ERROR';
  read: boolean;
  createdAt: string;
}

export const MOCK_USER: User = {
  id: 'user-001',
  fullName: 'Marcus Chen',
  email: 'marcus.chen@neurominer.io',
  referralCode: '0D942',
  role: 'USER',
  status: 'ACTIVE',
  createdAt: '2026-03-15',
  avatarInitials: 'MC',
};

export const MOCK_ADMIN: User = {
  id: 'admin-001',
  fullName: 'Admin User',
  email: 'admin@neurominer.io',
  referralCode: 'ADMIN1',
  role: 'ADMIN',
  status: 'ACTIVE',
  createdAt: '2026-01-01',
  avatarInitials: 'AU',
};

export const MOCK_WALLET: WalletData = {
  availableBalance: 3.60,
  totalDeposited: 250.00,
  totalWithdrawn: 0.00,
  totalEarnings: 3.60,
  totalCommissions: 0.00,
  accumulatedEarnings: 3.60,
  todayEarnings: 0.00,
};

export const MOCK_NODE: NodeData = {
  status: 'INACTIVE',
  todayEarnings: 0.00,
  totalEarnings: 3.60,
  efficiency: 100,
  multiplier: 1,
  cycle: null,
  activationDate: null,
  expirationDate: null,
};

export const MOCK_REFERRAL: ReferralData = {
  code: '0D942',
  level1Count: 3,
  level2Count: 1,
  level3Count: 0,
  level1Commission: 2.40,
  level2Commission: 0.80,
  level3Commission: 0.00,
  totalCommission: 3.20,
  availableCommission: 0.00,
};

export const MOCK_TRANSACTIONS: Transaction[] = [
  {
    id: 'txn-001',
    type: 'DEPOSIT',
    amount: 100.00,
    currency: 'USDT',
    network: 'BSC',
    status: 'CONFIRMED',
    txid: '0x7f4a2b8c9d1e3f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a',
    walletAddress: '0x58cD3ea0ce85D6bCe512CDF80A137eBc3C9c6E28',
    date: 'Aug 10, 2026',
    time: '14:32:07',
    notes: 'Initial deposit',
    userId: 'user-001',
  },
  {
    id: 'txn-002',
    type: 'DEPOSIT',
    amount: 150.00,
    currency: 'USDT',
    network: 'TRON',
    status: 'CONFIRMED',
    txid: 'a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2',
    walletAddress: 'TKeX7PHiJ1Y8eBPQ2UPnUs8LnxcDZynKr8',
    date: 'Aug 08, 2026',
    time: '09:15:44',
    notes: 'Second deposit',
    userId: 'user-001',
  },
  {
    id: 'txn-003',
    type: 'EARNINGS',
    amount: 1.20,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 12, 2026',
    time: '00:00:01',
    notes: 'Node daily earnings',
    userId: 'user-001',
  },
  {
    id: 'txn-004',
    type: 'EARNINGS',
    amount: 1.20,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 11, 2026',
    time: '00:00:01',
    notes: 'Node daily earnings',
    userId: 'user-001',
  },
  {
    id: 'txn-005',
    type: 'EARNINGS',
    amount: 1.20,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 10, 2026',
    time: '00:00:01',
    notes: 'Node daily earnings',
    userId: 'user-001',
  },
  {
    id: 'txn-006',
    type: 'COMMISSION',
    amount: 2.40,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 09, 2026',
    time: '11:22:33',
    notes: 'Level 1 referral commission — Sofia Martinez',
    userId: 'user-001',
  },
  {
    id: 'txn-007',
    type: 'COMMISSION',
    amount: 0.80,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 09, 2026',
    time: '11:22:35',
    notes: 'Level 2 referral commission — James Okafor',
    userId: 'user-001',
  },
  {
    id: 'txn-008',
    type: 'WITHDRAWAL',
    amount: 50.00,
    currency: 'USDT',
    network: 'BSC',
    status: 'PENDING',
    txid: null,
    walletAddress: '0xAb5801a7D398351b8bE11C439e05C5B3259aeC9B',
    date: 'Aug 13, 2026',
    time: '08:44:12',
    notes: null,
    userId: 'user-001',
  },
  {
    id: 'txn-009',
    type: 'ENERGY',
    amount: 0.15,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 13, 2026',
    time: '07:00:00',
    notes: 'Energy conversion',
    userId: 'user-001',
  },
  {
    id: 'txn-010',
    type: 'BONUS',
    amount: 0.50,
    currency: 'USDT',
    network: null,
    status: 'COMPLETED',
    txid: null,
    walletAddress: null,
    date: 'Aug 07, 2026',
    time: '12:00:00',
    notes: 'NFT bonus reward',
    userId: 'user-001',
  },
];

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 'notif-001',
    title: 'Deposit Confirmed',
    message: 'Your deposit of 150.00 USDT via TRON has been confirmed.',
    type: 'SUCCESS',
    read: false,
    createdAt: 'Aug 08, 2026',
  },
  {
    id: 'notif-002',
    title: 'Deposit Confirmed',
    message: 'Your deposit of 100.00 USDT via BSC has been confirmed.',
    type: 'SUCCESS',
    read: false,
    createdAt: 'Aug 10, 2026',
  },
  {
    id: 'notif-003',
    title: 'Withdrawal Pending',
    message: 'Your withdrawal request of 50.00 USDT is under review.',
    type: 'WARNING',
    read: false,
    createdAt: 'Aug 13, 2026',
  },
  {
    id: 'notif-004',
    title: 'Referral Commission',
    message: 'You received 2.40 USDT commission from Sofia Martinez.',
    type: 'INFO',
    read: true,
    createdAt: 'Aug 09, 2026',
  },
  {
    id: 'notif-005',
    title: 'Node Earnings',
    message: 'Your compute node generated 1.20 USDT today.',
    type: 'SUCCESS',
    read: true,
    createdAt: 'Aug 12, 2026',
  },
];

export const EARNINGS_CHART_DATA = [
  { date: 'Jul 30', earnings: 0.00, energy: 0.00 },
  { date: 'Jul 31', earnings: 0.00, energy: 0.00 },
  { date: 'Aug 01', earnings: 0.00, energy: 0.00 },
  { date: 'Aug 02', earnings: 0.00, energy: 0.00 },
  { date: 'Aug 03', earnings: 0.00, energy: 0.00 },
  { date: 'Aug 04', earnings: 0.00, energy: 0.00 },
  { date: 'Aug 05', earnings: 0.00, energy: 0.00 },
  { date: 'Aug 06', earnings: 0.00, energy: 0.05 },
  { date: 'Aug 07', earnings: 0.50, energy: 0.08 },
  { date: 'Aug 08', earnings: 0.00, energy: 0.10 },
  { date: 'Aug 09', earnings: 3.20, energy: 0.12 },
  { date: 'Aug 10', earnings: 1.20, energy: 0.11 },
  { date: 'Aug 11', earnings: 1.20, energy: 0.13 },
  { date: 'Aug 12', earnings: 1.20, energy: 0.15 },
];

export const DEMO_CREDENTIALS = {
  user: {
    email: 'marcus.chen@neurominer.io',
    password: 'Demo@NM2026',
  },
  // Admin credentials are not exposed in frontend code for security
  admin: {
    email: 'admin@neurominer.io',
    password: '',
  },
};